<div tid="float-menu-panel" class="float-menu-draft-count-container" (panstart)="onPanStart()" (panend)="onPanEnd()"
    (panmove)="onMenuMove($event)">
    <div id="floatMenuId" tid="float-menu" class="panel-draft-count" (click)="showFloatMenuWithDraftList()">
        Drafts ({{draftCount}})
    </div>
    <div class="item-line">
    </div>
    <div tid="float-menu-panel-icons" class="panel-icons" kendoTooltip position="top"
        tooltipClass="tooltip-adjust-right">
        <smart-icon class="item-icons light" name="add-note" title="Create Note (Type &quot;n&quot;)"
            (click)="_floatMenuService.showAddNoteDialog()">
        </smart-icon>
        <smart-icon class="item-icons light" name="add-contact" title="Create Contact (Type &quot;c&quot;)"
            (click)="_floatMenuService.showAddContactTemplate()">
        </smart-icon>
        <smart-icon class="item-icons light" name="add-entity" title="Create Entity (Type &quot;e&quot;)"
            (click)="_floatMenuService.showAddEntityDialog()">
        </smart-icon>

    </div>
</div>